import axios from 'axios';
const electionService = {
  async get(idElection) {
    const url = `/election/${idElection}`;
    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },
  async getElections(idElection) {
    const url = idElection === '' ? '/election/online' : `/election/online/${idElection}`;
    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },

  async validateElectionAccess(urlAccessKey) {
    var url = '';
    if (urlAccessKey) {
      url = `/election/access/${urlAccessKey}`;
    } else {
      url = '/election/access';
    }

    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },

  async accessElectionKey(idElection, accessKey) {
    var url = '';
    if (idElection && accessKey) {
      url = `/election/access/${idElection}/${accessKey}`;
    } else {
      url = '/election/access';
    }

    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  }
};
export default electionService;
